import React, { Component } from "react";
import DeleteAccount from "./../components/DeleteAccount";

class DeleteAccountPage extends Component {
    render() {
       return (
          <DeleteAccount {...this.props}/>
       )
    }
  }

export default DeleteAccountPage;



// WEBPACK FOOTER //
// ./src/containers/DeleteAccountPageContainer.js